import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M7.027 8 12 12.945 16.973 8 18.5 9.522 12 16 5.5 9.522 7.027 8z",
		clipRule: "evenodd"
	})
});
export default SvgArrowDownSmall;
